import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../providers/auth.service';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { SidebarService } from '../providers/sidebar.service';
import { Subject } from 'rxjs';
import { DbService } from '../providers/db.service';
import { UserFullInterface } from '../interfaces';
import { environment } from './../../environments/environment';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-menubar',
  standalone: true,
  imports: [TranslocoDirective, CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './menubar.component.html',
  styleUrls: ['./menubar.component.css']
})
export class MenuBarComponent implements OnInit {
  initials: UserFullInterface | null | undefined;
  // LANG SWITCHER
  currentLang: string;
  languages: string[]; // available languages
  // LANG SWITCHER

  environment = environment;

  public db = inject(DbService);
  public auth = inject(AuthService);
  private translocoService = inject(TranslocoService);
  private toastr = inject(ToastrService);
  public sb = inject(SidebarService);

  onChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const langCode = target.value;
    // Update the current language and set it as active in Transloco
    this.translocoService.setActiveLang(langCode);
    this.currentLang = langCode;
  }
  showToast(toastType: string, title: string, content?: string) {
    const varTimeOut = 4000;
    const varProgressBar = true;
    const varPositionClass = 'toast-top-center';
    if (toastType === 'success') {
      this.toastr.success(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    } else if (toastType === 'info') {
      this.toastr.info(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    } else {
      this.toastr.error(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    }
  }
  ngOnInit() {
    this.currentLang = this.translocoService.getActiveLang();
    const availableLangs = this.translocoService.getAvailableLangs();
    if (Array.isArray(availableLangs) && typeof availableLangs[0] === 'string') {
      this.languages = availableLangs as string[];
    } else {
      this.languages = (availableLangs as { id: string; label: string }[]).map(lang => lang.id);
    }
  }

  async LogoutCheck() {
    try {
      await this.auth.signOutAsync()
      this.showToast('success', `${this.translocoService.translate('toasts.logoutSuccessMessage', undefined, this.auth.currentUserSig()?.lang)}`)
    } catch (err) {
      console.log(err.code)
      this.showToast('error', `${this.translocoService.translate('toasts.logoutFailMessage', undefined, this.auth.currentUserSig()?.lang)}`)
    }
  }
}
